import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyARh1m9sAzC5zDO4VSmcyA7jW98dXro4wE",
  authDomain: "sandrapersonal-fb.firebaseapp.com",
  projectId: "sandrapersonal-fb",
  storageBucket: "sandrapersonal-fb.firebasestorage.app",
  messagingSenderId: "924629079498",
  appId: "1:924629079498:web:4226c1689e2f78f7846b33",
  measurementId: "G-LP4PLVQZP5"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();